

export const DATE_PLACES = [
    {
        date: "2026/02/06",
        dateName: "2月6日",
        city: "高雄",
        hotel: "洲際飯店",
        time: "13:30"
    },
    {
        date: "2026/02/07",
        dateName: "2月7日",
        city: "台北",
        hotel: "Ｗ hotel 酒店",
        time: "13:30"
    },
    {
        date: "2026/02/08",
        dateName: "2月8日",
        city: "台中",
        hotel: "林酒店",
        time: "13:30"
    },
];

export const EVENT_MONTH = DATE_PLACES[0].date.split("/")[1];

export const TIME_SLOTS = ["13:30"];

export const PROJECT_INFO = {
    image: "binghatti.webp",
    title: "阿布達比政府主導建商Aldar 重磅登台 | 阿布達比 Fahid島 × 杜拜 Athlon 雙建案\n限時台灣投資人專屬說明會 | 名額有限",
    name: "Aldar Properties",
    description: "ALDAR 是阿布達比政府主導的頂級開發商，由掌管主權基金 穆巴達拉的家族創立，市值超過 410 億迪拉姆。作為阿布達比房地產巨頭，ALDAR掌握近 95% 的土地資源，並打造了 法拉利樂園、阿布達比羅浮宮、華納兄弟主題樂園 等世界級地標，堅持最高國際建築標準。ALDAR 的項目已遍及 阿布達比、杜拜與拉斯海瑪，展現其雄厚實力與遠大格局。",
    projects: [
        {
            title: 'Fahid Beach Terraces',
            image: 'beach.webp',
            benefits: [
                {
                    title: '低密度稀有規劃',
                    text: '全島貨量有限，約 50% 戶型享一線海景，公寓僅佔 20%，主力為高端別墅產品'
                },
                {
                    title: '海島景觀難複製',
                    text: '11 公里海岸線＋天然紅樹林，稀缺景觀資源一次到位'
                },
                {
                    title: '私密純住宅社區',
                    text: '以家庭居住品質為核心，空間尺度寬裕、隱私性高，一房約 27 坪起。'
                },
                {
                    title: '島上壓軸 × 典藏級住宅',
                    text: '博物館群全陣容揭幕，最後一座典藏級住宅項目，未來將成為高端餐飲、零售與生活聚落新核心。'
                },
                {
                    title: '共享成熟生活機能',
                    text: '交屋即享 Saadiyat 與 Yas 島既有文化、商業與娛樂資源'
                }
            ],
            price: '一房起價350 萬AED(約台幣3000萬）'
        }, {
            title: 'Rise By Athlon',
            image: 'rise.webp',
            benefits: [
                {
                    title: '全球首創 × 足球豪門聯名',
                    text: '全球第一個與 Manchester United 聯名打造的住宅項目，強大品牌效應加持，具高度話題性與稀缺收藏價值。'
                },
                {
                    title: '杜拜人氣地段 × 冬季煙火日常',
                    text: '座落 Dubailand，緊鄰 Global Village，冬季可天天欣賞煙火秀，生活感十足。'
                },
                {
                    title: 'LEED 認證 × 超大型國際造鎮',
                    text: '位於阿聯酋首個取得 LEED 社區規劃與設計鉑金認證 的 Athlon 社區，集結國際學校、商場、醫療中心與多元運動設施，一站式生活圈。'
                },
                {
                    title: '運動生活社區 × 全齡友善規劃',
                    text: '杜拜首個以「運動生活方式」為核心的國際社區，配備專屬會所、自行車環線、親子步道、攀岩場等，打造健康、活力的現代居住模式。'
                },
                {
                    title: '交通便捷 × 直達全城核心',
                    text: '5 分鐘即達藍線地鐵延伸站，銜接 E611 / D54 主幹道'
                }
            ],
            price: '一房起價140  萬AED(約台幣1195萬）' 
        }
    ],
};
